import {
  BasicWorkspaceAccess,
  BasicWorkspaceSuccessEvent,
  trackEvent,
} from '@otter-ai/telemetry';
import { useCreateBasicWorkspaceMutation } from '#mutation';

export const useCreateBasicWorkspace = ({
  isNewUser,
  basicWorkspaceAccess,
  onSuccess,
  onError,
}: {
  isNewUser: boolean;
  basicWorkspaceAccess: BasicWorkspaceAccess;
  onSuccess?: () => void;
  onError?: (error: {
    status?: string;
    message?: string;
    code?: number;
  }) => void;
}) => {
  const {
    mutate: createBasicWorkspace,
    mutateAsync: createBasicWorkspaceAsync,
    isPending: isCreatingBasicWorkspace,
  } = useCreateBasicWorkspaceMutation({
    onSuccess: () => {
      trackEvent(
        BasicWorkspaceSuccessEvent({
          BasicWorkspaceAccess: basicWorkspaceAccess,
          IsNewUser: isNewUser,
        }),
      );

      if (onSuccess) {
        onSuccess();
      }
    },
    onError: (error) => {
      const customError = error as Error & { status?: string; code?: number };

      if (onError) {
        onError({
          status: customError.status,
          message: customError.message,
          code: customError.code,
        });
      }
    },
  });

  return {
    createBasicWorkspace,
    createBasicWorkspaceAsync,
    isCreatingBasicWorkspace,
  };
};
